"use-client";

import React from "react";
import Skeleton from "../skeletons/skeleton";

/** */
const CategorySuggestionBannerSkeleton = () => {
  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex w-full items-center justify-start gap-4">
        <div>
          <Skeleton variant="rounded" customStyle={{ width: "40px", height: "40px" }} animation="wave" />
        </div>
        <div className="flex w-full flex-col gap-4">
          <div>
            <Skeleton variant="rectangular" customStyle={{ width: "170px", height: "16px" }} animation="wave" />
          </div>
          <div>
            <Skeleton variant="rectangular" customStyle={{ width: "180px", height: "16px" }} animation="wave" />
          </div>
        </div>
      </div>
      <div>
        <Skeleton variant="rectangular" customStyle={{ width: "16px", height: "16px" }} animation="wave" />
      </div>
    </div>
  );
};

export default CategorySuggestionBannerSkeleton;
